import { cn } from '@/utils/utils';
import AppIcon from '@shelflix/ui-web/components/AppIcon';
import { Card } from '@shelflix/ui-web/components/ui/card';
import React from 'react';

export interface DashboardCardItem {
  title: string;
  icon: string;
  children: React.ReactNode;
  className?: string;
}

export function DashboardCard({ title, icon, children, className }: DashboardCardItem) {
  return (
    <Card className={cn(`gap-4 p-4`, className)} hasTable={false}>
      <div className="grid grid-cols-[auto_1fr] items-center gap-6 p-2">
        <AppIcon
          source="svg"
          name={title.toLowerCase()}
          svgContent={icon}
          size={40}
          weight={400}
          colorStyle={{ type: 'solid', color: '#FFF9F2' }}
        />
        <h3 className="text-[20px] font-normal text-[#FFF9F2]">{title}</h3>
      </div>
      {children}
    </Card>
  );
}
